import { TOAST_STATUS, toastActions } from '@leagueplatform/toast-messages';

export const useProfileToast = () => {
  const onSuccess = (msg: string) => {
    toastActions.add({
      type: TOAST_STATUS.SUCCESS,
      textId: msg,
    });
  };

  const onError = () => {
    toastActions.add({
      type: TOAST_STATUS.ERROR,
      textId: 'STR_PROFILE_SETTING_ERROR_MSG',
    });
  };

  return { onSuccess, onError };
};
